<!-- Mobile: Foxera Drawer Full -->
@if (responsiveService.isMobileView()) {
  <foxera-drawer-full
    [(visible)]="visible"
    [title]="getDialogTitle()"
    [showFooter]="true"
    [saveButtonType]="'simple-save'"
    [saveDisabled]="type() === 'title' && titleForm.invalid"
    [isSaving]="false"
    [showDeleteButton]="false"
    (onClose)="onHide()"
    (onSave)="onSave()">
    
    <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
  </foxera-drawer-full>
}

<!-- Desktop: Original Dialog -->
@if (!responsiveService.isMobileView()) {
  <p-dialog
    maskStyleClass="p-dialog-mask-style"
    [visible]="visible"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    styleClass="p-dialog-style !border-0 !rounded-[2.125rem] !w-[90vw] !max-w-[30rem] !max-h-[90vh] !bg-white overflow-hidden"
    (onHide)="onHide()">
    
    <ng-template #headless>
      <div class="w-full h-full p-[1.875rem] flex flex-col relative">
        <!-- Close Button -->
        <div class="absolute top-[1.875rem] right-[1.875rem] z-[60] size-[1.875rem] flex justify-center items-center select-none">
          <span
            (click)="onHide()"
            class="cursor-pointer select-none text-grey-300 icon-close-rounded text-[1.5rem] hover:text-[1.625rem] transition-all duration-100 ease-in-out">
          </span>
        </div>

        <!-- Header -->
        <div class="flex justify-between items-center flex-shrink-0">
          <h2 class="text-grey-950 text-headline3 font-medium leading-[100%] select-none">
            {{ getDialogTitle() }}
          </h2>
        </div>

        <!-- Content -->
        <div class="relative flex-1 min-h-0 mt-[1.75rem]">
          <ng-container *ngTemplateOutlet="dialogContent"></ng-container>
        </div>
      </div>
    </ng-template>
  </p-dialog>
}

<!-- Shared Dialog Content -->
<ng-template #dialogContent>
  <!-- Duration Dialog Content -->
  @if (type() === 'duration') {
    <div class="flex flex-col h-full">
      <!-- Scrollable Content -->
      <div class="flex-1 overflow-y-auto flex items-center justify-center">
        <div class="w-full max-w-sm px-4">
          <!-- Section Title -->
          <div class="text-center mb-4 md:mb-6">
            <p class="text-xs md:text-sm text-grey-600 mb-1">Section</p>
            <h3 class="text-base md:text-lg font-semibold text-grey-900">{{ sectionTitle() }}</h3>
          </div>

          <!-- Duration Display -->
          <div class="text-center mb-6 md:mb-8">
            <div class="inline-flex items-baseline gap-2">
              <span class="text-4xl md:text-5xl font-bold text-primary-600">{{ tempValue }}</span>
              <span class="text-lg md:text-xl font-medium text-grey-600">min</span>
            </div>
          </div>

          <!-- Slider -->
          <div class="mb-4 md:mb-6">
            <p-slider
              [(ngModel)]="tempValue"
              [min]="1"
              [max]="60"
              [step]="1"
              styleClass="w-full">
            </p-slider>
            <div class="flex justify-between mt-2 text-xs text-grey-500">
              <span>1 min</span>
              <span>60 min</span>
            </div>
          </div>

          <!-- Quick Select -->
          <div class="grid grid-cols-4 gap-2 pb-4">
            <button
              type="button"
              *ngFor="let preset of [5, 10, 15, 20]"
              (click)="tempValue = preset"
              [class.!bg-primary-600]="tempValue === preset"
              [class.!text-white]="tempValue === preset"
              class="cursor-pointer px-3 py-2 text-sm font-medium text-grey-700 bg-grey-100 rounded-lg hover:bg-grey-200 transition-colors">
              {{ preset }}
            </button>
          </div>
        </div>
      </div>

      <!-- Action Buttons (Desktop Only) -->
      @if (!responsiveService.isMobileView()) {
        <div class="shrink-0">
          <div class="flex justify-end items-center gap-3 pt-4 border-t border-gray-100">
            <p-button
              label="Cancel"
              severity="secondary"
              size="large"
              outlined="true"
              (click)="onHide()"
              class="select-none"
              styleClass="!min-w-[6.2rem] !rounded-xl"
            />
            <p-button
              label="Save"
              severity="contrast"
              size="large"
              (click)="onSave()"
              class="select-none"
              styleClass="!min-w-[6.2rem] !rounded-xl"
            />
          </div>
        </div>
      }
    </div>
  }

  <!-- Day Title Dialog Content -->
  @if (type() === 'title') {
    <form [formGroup]="titleForm" class="h-full">
      <div class="flex flex-col h-full">
        <!-- Scrollable Content -->
        <div class="flex-1 overflow-y-auto">
          <div class="flex flex-col gap-5">
            <!-- Day Number Display -->
            <div class="mb-4 text-center">
              <div class="inline-flex items-center justify-center w-12 h-12 bg-primary-100 rounded-lg border-2 border-primary-300 mb-2">
                <span class="text-lg font-bold text-primary-600">{{ dayNumber() }}</span>
              </div>
              <p class="text-xs text-grey-500">Day Number</p>
            </div>

            <!-- Title Input -->
            <div class="pb-7">
              <foxera-input-text
                [config]="inputConfig"
                name="title"
                id="title"
                formControlName="title"
                [formSubmitted]="formSubmitted"
                (keydown.enter)="onSave()"
                (keydown.escape)="onHide()">
              </foxera-input-text>
            </div>
          </div>
        </div>

        <!-- Action Buttons (Desktop Only) -->
        @if (!responsiveService.isMobileView()) {
          <div class="shrink-0">
            <div class="flex justify-end items-center gap-3 pt-4 border-t border-gray-100">
              <p-button
                label="Cancel"
                severity="secondary"
                size="large"
                outlined="true"
                (click)="onHide()"
                class="select-none"
                styleClass="!min-w-[6.2rem] !rounded-xl"
              />
              <p-button
                label="Save"
                severity="primary"
                size="large"
                (click)="onSave()"
                class="select-none"
                styleClass="!min-w-[6.2rem] !rounded-xl"
              />
            </div>
          </div>
        }
      </div>
    </form>
  }
</ng-template>
